const projects = [
  {
    name: 'tapped',
    displayName: 'TAPPED',
    githubLink: 'https://github.com/krandles/bottle-share-frontend',
    hostedLink: 'http://tapped.kevinrandles.com',
    hostedLinkText: 'tapped.kevinrandles.com',
    description: 'A multi-purpose app for craft beer enthusiasts, Tapped features beer & brewery listings/reviews and craft beer-related event listings. Users can create and manage public or private events, discuss and post photos of events, and contribute to beer reviews/listings.',
    tech: ['React', 'Redux', 'React Router', 'Semantic UI', 'Rails', 'PostgreSQL'],
    date: 'March 2018 (ongoing)',
    images: ['images/tapped1.png', 'images/tapped2.png', 'images/tapped3.png']
  },
  {
    name: 'tileMatcher',
    displayName: 'TILE MATCHER',
    githubLink: 'https://github.com/krandles/Tile-Matcher-Frontendd',
    hostedLink: 'http://tile-matcher.kevinrandles.com',
    hostedLinkText: 'tile-matcher.kevinrandles.com',
    description: 'A Concentration-style tile-matching game built with vanilla JavaScript, with support for multiple tilesets loaded from a Rails API.',
    tech: ['JavaScript', 'Rails', 'HTML', 'CSS'],
    date: 'February 2018',
    images: ['images/tile-matcher1.png']
  },
  {
    name: 'getErDone',
    displayName: "GET 'ER DONE",
    githubLink: 'https://github.com/krandles/get-er-done',
    hostedLink: 'http://geterdone.kevinrandles.com',
    hostedLinkText: 'get-er-done.kevinrandles.com',
    description: "A todo-list app incorporating gamification elements, Get 'Er Done allows users to manage tasks by project or category, earning experience points towards levelling up when tasks or projects are completed.",
    tech: ['Ruby', 'Rails', 'Bootstrap'],
    date: 'February 2018',
    images: ['images/geterdone1.png', 'images/geterdone2.png', 'images/geterdone3.png']
  },
  {
    name: 'mediocreReads',
    displayName: 'MEDIOCRE READS',
    githubLink: 'https://github.com/krandles/mediocre-reads-cli',
    hostedLink: '',
    hostedLinkText: '',
    description: "A Ruby CLI app that interfaces with the Goodreads API, giving users the ability to search authors and books, and list books they've reviewed.",
    tech: ['Ruby', 'Nokogiri', 'Sinatra', 'SQLite'],
    date: 'January 2018',
    images: []
  }
];

export default projects;



// WEBPACK FOOTER //
// ./src/data/projects.js